/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as SubscriptionsRouteImport } from './routes/subscriptions'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ProductionRouteImport } from './routes/production'
import { Route as PayoutsRouteImport } from './routes/payouts'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InfluencersRouteImport } from './routes/influencers'
import { Route as EmailsRouteImport } from './routes/emails'
import { Route as DisputesRouteImport } from './routes/disputes'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as CouponsRouteImport } from './routes/coupons'
import { Route as BundlesRouteImport } from './routes/bundles'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as TransactionsIdRouteImport } from './routes/transactions.$id'
import { Route as SubscriptionsIdRouteImport } from './routes/subscriptions.$id'
import { Route as SettingsUsersRouteImport } from './routes/settings.users'
import { Route as SettingsChannelsRouteImport } from './routes/settings.channels'
import { Route as SettingsBrandingRouteImport } from './routes/settings.branding'
import { Route as SettingsApiKeysRouteImport } from './routes/settings.api-keys'
import { Route as ProductsBundlesRouteImport } from './routes/products.bundles'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as OrdersIdRouteImport } from './routes/orders.$id'
import { Route as EmailsTemplatesRouteImport } from './routes/emails.templates'
import { Route as EmailsSequencesRouteImport } from './routes/emails.sequences'
import { Route as EmailsSendsRouteImport } from './routes/emails.sends'
import { Route as EmailsBroadcastsRouteImport } from './routes/emails.broadcasts'
import { Route as CustomersIdRouteImport } from './routes/customers.$id'
import { Route as CouponsIdRouteImport } from './routes/coupons.$id'

const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsRoute = SubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const ShippingRoute = ShippingRouteImport.update({
  id: '/shipping',
  path: '/shipping',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundsRoute = RefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductionRoute = ProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsRoute = PayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InfluencersRoute = InfluencersRouteImport.update({
  id: '/influencers',
  path: '/influencers',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsRoute = EmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => rootRouteImport,
} as any)
const DisputesRoute = DisputesRouteImport.update({
  id: '/disputes',
  path: '/disputes',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const CouponsRoute = CouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => rootRouteImport,
} as any)
const BundlesRoute = BundlesRouteImport.update({
  id: '/bundles',
  path: '/bundles',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const TransactionsIdRoute = TransactionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TransactionsRoute,
} as any)
const SubscriptionsIdRoute = SubscriptionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SubscriptionsRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsChannelsRoute = SettingsChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBrandingRoute = SettingsBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsApiKeysRoute = SettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => SettingsRoute,
} as any)
const ProductsBundlesRoute = ProductsBundlesRouteImport.update({
  id: '/bundles',
  path: '/bundles',
  getParentRoute: () => ProductsRoute,
} as any)
const ProductsSlugRoute = ProductsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ProductsRoute,
} as any)
const OrdersIdRoute = OrdersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => OrdersRoute,
} as any)
const EmailsTemplatesRoute = EmailsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => EmailsRoute,
} as any)
const EmailsSequencesRoute = EmailsSequencesRouteImport.update({
  id: '/sequences',
  path: '/sequences',
  getParentRoute: () => EmailsRoute,
} as any)
const EmailsSendsRoute = EmailsSendsRouteImport.update({
  id: '/sends',
  path: '/sends',
  getParentRoute: () => EmailsRoute,
} as any)
const EmailsBroadcastsRoute = EmailsBroadcastsRouteImport.update({
  id: '/broadcasts',
  path: '/broadcasts',
  getParentRoute: () => EmailsRoute,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CustomersRoute,
} as any)
const CouponsIdRoute = CouponsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CouponsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/bundles': typeof BundlesRoute
  '/coupons': typeof CouponsRouteWithChildren
  '/customers': typeof CustomersRouteWithChildren
  '/disputes': typeof DisputesRoute
  '/emails': typeof EmailsRouteWithChildren
  '/influencers': typeof InfluencersRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRouteWithChildren
  '/payouts': typeof PayoutsRoute
  '/production': typeof ProductionRoute
  '/products': typeof ProductsRouteWithChildren
  '/refunds': typeof RefundsRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/shipping': typeof ShippingRoute
  '/subscriptions': typeof SubscriptionsRouteWithChildren
  '/transactions': typeof TransactionsRouteWithChildren
  '/coupons/$id': typeof CouponsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/emails/broadcasts': typeof EmailsBroadcastsRoute
  '/emails/sends': typeof EmailsSendsRoute
  '/emails/sequences': typeof EmailsSequencesRoute
  '/emails/templates': typeof EmailsTemplatesRoute
  '/orders/$id': typeof OrdersIdRoute
  '/products/$slug': typeof ProductsSlugRoute
  '/products/bundles': typeof ProductsBundlesRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/subscriptions/$id': typeof SubscriptionsIdRoute
  '/transactions/$id': typeof TransactionsIdRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/bundles': typeof BundlesRoute
  '/coupons': typeof CouponsRouteWithChildren
  '/customers': typeof CustomersRouteWithChildren
  '/disputes': typeof DisputesRoute
  '/emails': typeof EmailsRouteWithChildren
  '/influencers': typeof InfluencersRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRouteWithChildren
  '/payouts': typeof PayoutsRoute
  '/production': typeof ProductionRoute
  '/products': typeof ProductsRouteWithChildren
  '/refunds': typeof RefundsRoute
  '/reports': typeof ReportsRoute
  '/shipping': typeof ShippingRoute
  '/subscriptions': typeof SubscriptionsRouteWithChildren
  '/transactions': typeof TransactionsRouteWithChildren
  '/coupons/$id': typeof CouponsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/emails/broadcasts': typeof EmailsBroadcastsRoute
  '/emails/sends': typeof EmailsSendsRoute
  '/emails/sequences': typeof EmailsSequencesRoute
  '/emails/templates': typeof EmailsTemplatesRoute
  '/orders/$id': typeof OrdersIdRoute
  '/products/$slug': typeof ProductsSlugRoute
  '/products/bundles': typeof ProductsBundlesRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/subscriptions/$id': typeof SubscriptionsIdRoute
  '/transactions/$id': typeof TransactionsIdRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/bundles': typeof BundlesRoute
  '/coupons': typeof CouponsRouteWithChildren
  '/customers': typeof CustomersRouteWithChildren
  '/disputes': typeof DisputesRoute
  '/emails': typeof EmailsRouteWithChildren
  '/influencers': typeof InfluencersRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRouteWithChildren
  '/payouts': typeof PayoutsRoute
  '/production': typeof ProductionRoute
  '/products': typeof ProductsRouteWithChildren
  '/refunds': typeof RefundsRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/shipping': typeof ShippingRoute
  '/subscriptions': typeof SubscriptionsRouteWithChildren
  '/transactions': typeof TransactionsRouteWithChildren
  '/coupons/$id': typeof CouponsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/emails/broadcasts': typeof EmailsBroadcastsRoute
  '/emails/sends': typeof EmailsSendsRoute
  '/emails/sequences': typeof EmailsSequencesRoute
  '/emails/templates': typeof EmailsTemplatesRoute
  '/orders/$id': typeof OrdersIdRoute
  '/products/$slug': typeof ProductsSlugRoute
  '/products/bundles': typeof ProductsBundlesRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/subscriptions/$id': typeof SubscriptionsIdRoute
  '/transactions/$id': typeof TransactionsIdRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/bundles'
    | '/coupons'
    | '/customers'
    | '/disputes'
    | '/emails'
    | '/influencers'
    | '/login'
    | '/orders'
    | '/payouts'
    | '/production'
    | '/products'
    | '/refunds'
    | '/reports'
    | '/settings'
    | '/shipping'
    | '/subscriptions'
    | '/transactions'
    | '/coupons/$id'
    | '/customers/$id'
    | '/emails/broadcasts'
    | '/emails/sends'
    | '/emails/sequences'
    | '/emails/templates'
    | '/orders/$id'
    | '/products/$slug'
    | '/products/bundles'
    | '/settings/api-keys'
    | '/settings/branding'
    | '/settings/channels'
    | '/settings/users'
    | '/subscriptions/$id'
    | '/transactions/$id'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/bundles'
    | '/coupons'
    | '/customers'
    | '/disputes'
    | '/emails'
    | '/influencers'
    | '/login'
    | '/orders'
    | '/payouts'
    | '/production'
    | '/products'
    | '/refunds'
    | '/reports'
    | '/shipping'
    | '/subscriptions'
    | '/transactions'
    | '/coupons/$id'
    | '/customers/$id'
    | '/emails/broadcasts'
    | '/emails/sends'
    | '/emails/sequences'
    | '/emails/templates'
    | '/orders/$id'
    | '/products/$slug'
    | '/products/bundles'
    | '/settings/api-keys'
    | '/settings/branding'
    | '/settings/channels'
    | '/settings/users'
    | '/subscriptions/$id'
    | '/transactions/$id'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/bundles'
    | '/coupons'
    | '/customers'
    | '/disputes'
    | '/emails'
    | '/influencers'
    | '/login'
    | '/orders'
    | '/payouts'
    | '/production'
    | '/products'
    | '/refunds'
    | '/reports'
    | '/settings'
    | '/shipping'
    | '/subscriptions'
    | '/transactions'
    | '/coupons/$id'
    | '/customers/$id'
    | '/emails/broadcasts'
    | '/emails/sends'
    | '/emails/sequences'
    | '/emails/templates'
    | '/orders/$id'
    | '/products/$slug'
    | '/products/bundles'
    | '/settings/api-keys'
    | '/settings/branding'
    | '/settings/channels'
    | '/settings/users'
    | '/subscriptions/$id'
    | '/transactions/$id'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  BundlesRoute: typeof BundlesRoute
  CouponsRoute: typeof CouponsRouteWithChildren
  CustomersRoute: typeof CustomersRouteWithChildren
  DisputesRoute: typeof DisputesRoute
  EmailsRoute: typeof EmailsRouteWithChildren
  InfluencersRoute: typeof InfluencersRoute
  LoginRoute: typeof LoginRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  PayoutsRoute: typeof PayoutsRoute
  ProductionRoute: typeof ProductionRoute
  ProductsRoute: typeof ProductsRouteWithChildren
  RefundsRoute: typeof RefundsRoute
  ReportsRoute: typeof ReportsRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ShippingRoute: typeof ShippingRoute
  SubscriptionsRoute: typeof SubscriptionsRouteWithChildren
  TransactionsRoute: typeof TransactionsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shipping': {
      id: '/shipping'
      path: '/shipping'
      fullPath: '/shipping'
      preLoaderRoute: typeof ShippingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refunds': {
      id: '/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof RefundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production': {
      id: '/production'
      path: '/production'
      fullPath: '/production'
      preLoaderRoute: typeof ProductionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts': {
      id: '/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof PayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/influencers': {
      id: '/influencers'
      path: '/influencers'
      fullPath: '/influencers'
      preLoaderRoute: typeof InfluencersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails': {
      id: '/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof EmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disputes': {
      id: '/disputes'
      path: '/disputes'
      fullPath: '/disputes'
      preLoaderRoute: typeof DisputesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coupons': {
      id: '/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof CouponsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bundles': {
      id: '/bundles'
      path: '/bundles'
      fullPath: '/bundles'
      preLoaderRoute: typeof BundlesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/transactions/$id': {
      id: '/transactions/$id'
      path: '/$id'
      fullPath: '/transactions/$id'
      preLoaderRoute: typeof TransactionsIdRouteImport
      parentRoute: typeof TransactionsRoute
    }
    '/subscriptions/$id': {
      id: '/subscriptions/$id'
      path: '/$id'
      fullPath: '/subscriptions/$id'
      preLoaderRoute: typeof SubscriptionsIdRouteImport
      parentRoute: typeof SubscriptionsRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/channels': {
      id: '/settings/channels'
      path: '/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof SettingsChannelsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/branding': {
      id: '/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof SettingsBrandingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/api-keys': {
      id: '/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof SettingsApiKeysRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/products/bundles': {
      id: '/products/bundles'
      path: '/bundles'
      fullPath: '/products/bundles'
      preLoaderRoute: typeof ProductsBundlesRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/products/$slug': {
      id: '/products/$slug'
      path: '/$slug'
      fullPath: '/products/$slug'
      preLoaderRoute: typeof ProductsSlugRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/orders/$id': {
      id: '/orders/$id'
      path: '/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof OrdersIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/emails/templates': {
      id: '/emails/templates'
      path: '/templates'
      fullPath: '/emails/templates'
      preLoaderRoute: typeof EmailsTemplatesRouteImport
      parentRoute: typeof EmailsRoute
    }
    '/emails/sequences': {
      id: '/emails/sequences'
      path: '/sequences'
      fullPath: '/emails/sequences'
      preLoaderRoute: typeof EmailsSequencesRouteImport
      parentRoute: typeof EmailsRoute
    }
    '/emails/sends': {
      id: '/emails/sends'
      path: '/sends'
      fullPath: '/emails/sends'
      preLoaderRoute: typeof EmailsSendsRouteImport
      parentRoute: typeof EmailsRoute
    }
    '/emails/broadcasts': {
      id: '/emails/broadcasts'
      path: '/broadcasts'
      fullPath: '/emails/broadcasts'
      preLoaderRoute: typeof EmailsBroadcastsRouteImport
      parentRoute: typeof EmailsRoute
    }
    '/customers/$id': {
      id: '/customers/$id'
      path: '/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof CustomersRoute
    }
    '/coupons/$id': {
      id: '/coupons/$id'
      path: '/$id'
      fullPath: '/coupons/$id'
      preLoaderRoute: typeof CouponsIdRouteImport
      parentRoute: typeof CouponsRoute
    }
  }
}

interface CouponsRouteChildren {
  CouponsIdRoute: typeof CouponsIdRoute
}

const CouponsRouteChildren: CouponsRouteChildren = {
  CouponsIdRoute: CouponsIdRoute,
}

const CouponsRouteWithChildren =
  CouponsRoute._addFileChildren(CouponsRouteChildren)

interface CustomersRouteChildren {
  CustomersIdRoute: typeof CustomersIdRoute
}

const CustomersRouteChildren: CustomersRouteChildren = {
  CustomersIdRoute: CustomersIdRoute,
}

const CustomersRouteWithChildren = CustomersRoute._addFileChildren(
  CustomersRouteChildren,
)

interface EmailsRouteChildren {
  EmailsBroadcastsRoute: typeof EmailsBroadcastsRoute
  EmailsSendsRoute: typeof EmailsSendsRoute
  EmailsSequencesRoute: typeof EmailsSequencesRoute
  EmailsTemplatesRoute: typeof EmailsTemplatesRoute
}

const EmailsRouteChildren: EmailsRouteChildren = {
  EmailsBroadcastsRoute: EmailsBroadcastsRoute,
  EmailsSendsRoute: EmailsSendsRoute,
  EmailsSequencesRoute: EmailsSequencesRoute,
  EmailsTemplatesRoute: EmailsTemplatesRoute,
}

const EmailsRouteWithChildren =
  EmailsRoute._addFileChildren(EmailsRouteChildren)

interface OrdersRouteChildren {
  OrdersIdRoute: typeof OrdersIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersIdRoute: OrdersIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

interface ProductsRouteChildren {
  ProductsSlugRoute: typeof ProductsSlugRoute
  ProductsBundlesRoute: typeof ProductsBundlesRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsSlugRoute: ProductsSlugRoute,
  ProductsBundlesRoute: ProductsBundlesRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

interface SettingsRouteChildren {
  SettingsApiKeysRoute: typeof SettingsApiKeysRoute
  SettingsBrandingRoute: typeof SettingsBrandingRoute
  SettingsChannelsRoute: typeof SettingsChannelsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsApiKeysRoute: SettingsApiKeysRoute,
  SettingsBrandingRoute: SettingsBrandingRoute,
  SettingsChannelsRoute: SettingsChannelsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface SubscriptionsRouteChildren {
  SubscriptionsIdRoute: typeof SubscriptionsIdRoute
}

const SubscriptionsRouteChildren: SubscriptionsRouteChildren = {
  SubscriptionsIdRoute: SubscriptionsIdRoute,
}

const SubscriptionsRouteWithChildren = SubscriptionsRoute._addFileChildren(
  SubscriptionsRouteChildren,
)

interface TransactionsRouteChildren {
  TransactionsIdRoute: typeof TransactionsIdRoute
}

const TransactionsRouteChildren: TransactionsRouteChildren = {
  TransactionsIdRoute: TransactionsIdRoute,
}

const TransactionsRouteWithChildren = TransactionsRoute._addFileChildren(
  TransactionsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  BundlesRoute: BundlesRoute,
  CouponsRoute: CouponsRouteWithChildren,
  CustomersRoute: CustomersRouteWithChildren,
  DisputesRoute: DisputesRoute,
  EmailsRoute: EmailsRouteWithChildren,
  InfluencersRoute: InfluencersRoute,
  LoginRoute: LoginRoute,
  OrdersRoute: OrdersRouteWithChildren,
  PayoutsRoute: PayoutsRoute,
  ProductionRoute: ProductionRoute,
  ProductsRoute: ProductsRouteWithChildren,
  RefundsRoute: RefundsRoute,
  ReportsRoute: ReportsRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ShippingRoute: ShippingRoute,
  SubscriptionsRoute: SubscriptionsRouteWithChildren,
  TransactionsRoute: TransactionsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
